// Inspired by: https://stackoverflow.com/a/57950393
const DevConsoleLog = (data: unknown): void => {
  if (process.env.NODE_ENV === 'production') return;
  console.log(data);
};

export default DevConsoleLog;
